import clsx from "clsx";
import { imgHomeMenuPlayer } from "@/shared/assets/img";

type Props = {
  characterName: string;
  text: string;
  date?: string;
  isOdd: boolean;
};

export default function EstateHistoryLog({ characterName, text, date, isOdd }: Props) {
  return (
    <div
      className={clsx(
        "flex items-center gap-[0.5625rem] p-[0.5625rem] rounded-xl",
        isOdd && "bg-dark-800",
      )}
    >
      <div className="relative flex-shrink-0 size-9.5 rounded-md overflow-hidden">
        <img src={imgHomeMenuPlayer} className="size-full object-cover" alt="avatar" />
      </div>
      <div className="flex flex-col gap-0.5">
        <p className="text-15 font-bold">{characterName}:</p>
        <p className="mr-2 text-15 font-medium text-white/60">{text}</p>
      </div>
      <p className="flex shrink-0 self-start ml-auto mt-[0.3125rem] mr-1.5 text-13 text-white/30 font-medium">
        {date}
      </p>
    </div>
  );
}
